import { useQuery } from "@tanstack/react-query";

import {
  getWithdrawalApproval,
  type SortOrder,
  type WithdrawalListOrderBy,
  type WithdrawalRequestStatus,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { WITHDRAWAL_APPROVALS_QUERY_KEYS } from "./queryKeys";

export interface WithdrawalApprovalsQueryParams {
  offset?: number;
  limit?: number;
  status?: WithdrawalRequestStatus | null;
  searchQuery?: string;
  orderBy?: WithdrawalListOrderBy;
  sortOrder?: SortOrder;
}

export function useWithdrawalApprovalsQuery(
  params: WithdrawalApprovalsQueryParams,
) {
  const { offset, limit, status, searchQuery, orderBy, sortOrder } = params;

  return useQuery({
    queryKey: WITHDRAWAL_APPROVALS_QUERY_KEYS.list(
      offset,
      limit,
      status,
      searchQuery,
      orderBy,
      sortOrder,
    ),
    queryFn: processResponse(() =>
      getWithdrawalApproval(
        offset,
        limit,
        status,
        searchQuery,
        orderBy,
        sortOrder,
      ),
    ),
  });
}
